import dayjs from "dayjs";
import { Combo, InputFactoryProp } from "../../../../shared/interfaces";

export const getInputsFilter = (branchesCombo: Combo[]): InputFactoryProp[] => {
  return [
    {
      element: "select",
      isMulti: true,
      placeHolder: "Ramo",
      items: branchesCombo,
      name: "branch",
    },
    {
      element: 'input',
      placeHolder: 'Palabra clave',
      allowClear: true,
      name: 'keyword',
      isMulti: false,
    },
  ];
};